import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.85, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const ChapterHeading = ({ number, label, title, dark = false }) => (
  <Reveal>
    <p
      className={`text-xs tracking-[0.25em] uppercase font-bold mb-5 flex items-center gap-3 ${
        dark ? "text-brand" : "text-brand-dark"
      }`}
    >
      <span className={dark ? "text-sand/40" : "text-charcoal/40"}>{number}</span>
      <span className={`h-px w-10 ${dark ? "bg-sand/30" : "bg-charcoal/30"}`} aria-hidden="true" />
      {label}
    </p>
    <h2
      className={`font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight font-bold leading-[1.02] ${
        dark ? "text-sand" : "text-charcoal"
      }`}
    >
      {title}
    </h2>
  </Reveal>
);

export { EASE };
